import { render, staticRenderFns } from "./FollowUpStats.vue?vue&type=template&id=6fa4d300&"
import script from "./FollowUpStats.vue?vue&type=script&lang=js&"
export * from "./FollowUpStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports